{
  "vitalsEntry": {
    "title": "वाइटल साइन्स",
    "subtitle": "वाइटल साइन्स रिकॉर्ड करें और देखें",
    "printLabel": "वाइटल्स प्रिंट करें",
    "recordSection": "वाइटल्स रिकॉर्ड करें",
    "save": "वाइटल्स रिकॉर्ड करें",
    "cancel": "रद्द करें",
    "saving": "रिकॉर्ड हो रहा है...",
    "recordedSuccess": "वाइटल्स सफलतापूर्वक रिकॉर्ड किए गए",
    "recordedError": "वाइटल्स रिकॉर्ड करने में विफल",
    "invalidEncounter": "एन्काउंटर आईडी अमान्य है।",
    "historyTitle": "हाल के वाइटल्स",
    "loadingHistory": "वाइटल्स लोड हो रहे हैं...",
    "loadError": "वाइटल्स लोड करने में विफल।",
    "emptyHistory": "इस एन्काउंटर के लिए कोई वाइटल्स रिकॉर्ड नहीं हैं।",
    "morseTitle": "मॉर्स फॉल स्केल",
    "bradenTitle": "ब्रेडेन स्केल (प्रेशर इंजरी रिस्क)",
    "riskScalesSaved": "जोखिम स्कोर रिकॉर्ड किए गए",
    "riskScalesFailed": "वाइटल्स सहेजे गए, लेकिन जोखिम स्कोर रिकॉर्ड नहीं हुए"
  },
  "vitals": {
    "systolic": "सिस्टोलिक BP",
    "diastolic": "डायस्टोलिक BP",
    "heartRate": "हृदय गति",
    "respiratoryRate": "श्वसन दर",
    "temperature": "तापमान",
    "oxygenSaturation": "ऑक्सीजन संतृप्ति (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "दर्द स्कोर",
    "weight": "वज़न",
    "height": "ऊँचाई",
    "bmi": "BMI",
    "rangeError": "{{field}} {{min}} और {{max}} के बीच होना चाहिए",
    "placeholders": {
      "temperature": "उदा. 37.0",
      "heartRate": "उदा. 72",
      "respiratoryRate": "उदा. 16",
      "oxygenSaturation": "उदा. 98",
      "systolic": "उदा. 120",
      "diastolic": "उदा. 80",
      "weight": "उदा. 70.5",
      "height": "उदा. 175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "सामान्य",
    "borderline": "सीमावर्ती",
    "abnormal": "असामान्य",
    "critical": "गंभीर"
  },
  "tableHeaders": {
    "dateTime": "दिनांक/समय",
    "temperature": "तापमान",
    "heartRate": "हृदय गति",
    "respiratoryRate": "श्वसन",
    "bloodPressure": "BP",
    "oxygenSaturation": "SpO2",
    "weight": "वज़न",
    "height": "ऊँचाई",
    "pain": "दर्द"
  },
  "io": {
    "title": "इनटेक और आउटपुट",
    "addRecord": "रिकॉर्ड जोड़ें",
    "addRecordSection": "I/O रिकॉर्ड जोड़ें",
    "loading": "I/O रिकॉर्ड लोड हो रहे हैं...",
    "loadError": "I/O रिकॉर्ड लोड करने में विफल।",
    "empty": "इस एन्काउंटर के लिए कोई I/O रिकॉर्ड दर्ज नहीं हैं।",
    "totals": {
      "intake": "कुल इनटेक",
      "output": "कुल आउटपुट",
      "balance": "शुद्ध संतुलन",
      "totalsRow": "कुल",
      "netLabel": "शुद्ध"
    },
    "negativeWarning": "नकारात्मक संतुलन — द्रव स्थिति की समीक्षा करें",
    "columns": {
      "dateTime": "दिनांक/समय",
      "type": "प्रकार",
      "category": "श्रेणी",
      "amount": "मात्रा (ml)",
      "notes": "टिप्पणी"
    },
    "fields": {
      "type": "प्रकार",
      "category": "श्रेणी",
      "amount": "मात्रा (ml)",
      "notes": "टिप्पणी"
    },
    "type": {
      "intake": "इनटेक",
      "output": "आउटपुट"
    },
    "categoryPlaceholder": "श्रेणी चुनें...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "वैकल्पिक टिप्पणी...",
    "save": "रिकॉर्ड सहेजें",
    "cancel": "रद्द करें",
    "missingValueShort": "--",
    "toast": {
      "added": "I/O रिकॉर्ड जोड़ा गया",
      "addFailed": "I/O रिकॉर्ड जोड़ने में विफल",
      "missingFields": "कृपया आवश्यक फ़ील्ड भरें"
    }
  },
  "intake": {
    "oral": "मौखिक",
    "iv": "IV",
    "bloodProducts": "रक्त उत्पाद",
    "tpn": "TPN",
    "tubeFeeding": "ट्यूब फीडिंग",
    "other": "अन्य"
  },
  "output": {
    "urine": "मूत्र",
    "drain": "ड्रेन",
    "emesis": "उल्टी",
    "stool": "मल",
    "bloodLoss": "रक्तस्राव",
    "ngSuction": "NG सक्शन",
    "other": "अन्य"
  },
  "wound": {
    "title": "घाव देखभाल दस्तावेज़ीकरण",
    "subtitle": "एन्काउंटर #{{id}} — संरचित घाव मूल्यांकन",
    "newAssessment": "नया घाव मूल्यांकन",
    "dimensionsTitle": "आयाम (सेमी)",
    "woundBedTitle": "घाव का तल (%)",
    "woundBedTotalWarning": "कुल: {{total}}% (100% होना चाहिए)",
    "woundBedTotalOk": "कुल: 100%",
    "previousTitle": "पिछले मूल्यांकन",
    "empty": "इस एन्काउंटर के लिए कोई घाव मूल्यांकन दर्ज नहीं है।",
    "invalidEncounter": "एन्काउंटर आईडी अमान्य है।",
    "save": "मूल्यांकन सहेजें",
    "savedSuccess": "घाव मूल्यांकन दर्ज किया गया",
    "savedError": "घाव मूल्यांकन सहेजने में विफल",
    "fields": {
      "woundType": "घाव का प्रकार",
      "location": "स्थान",
      "stage": "चरण",
      "length": "लंबाई",
      "width": "चौड़ाई",
      "depth": "गहराई",
      "granulation": "ग्रैन्युलेशन",
      "slough": "स्लॉफ",
      "eschar": "एस्कर",
      "epithelial": "एपिथीलियल",
      "drainageType": "स्राव का प्रकार",
      "drainageAmount": "स्राव की मात्रा",
      "surroundingSkin": "आसपास की त्वचा",
      "treatment": "लागू उपचार",
      "painScore": "दर्द स्कोर (0-10)",
      "notes": "टिप्पणी"
    },
    "placeholders": {
      "length": "उदा. 3.5",
      "width": "उदा. 2.0",
      "depth": "उदा. 0.5",
      "treatment": "लागू घाव देखभाल का वर्णन करें...",
      "notes": "अतिरिक्त अवलोकन..."
    },
    "history": {
      "dimensionsLabel": "आयाम",
      "drainageLabel": "स्राव",
      "painLabel": "दर्द",
      "treatmentLabel": "उपचार"
    },
    "stage": {
      "stage1": "चरण 1",
      "stage2": "चरण 2",
      "stage3": "चरण 3",
      "stage4": "चरण 4",
      "unstageable": "चरण निर्धारण योग्य नहीं",
      "deepTissue": "गहरे ऊतक की चोट",
      "na": "N/A"
    },
    "drainageType": {
      "none": "कोई नहीं",
      "serous": "सीरस",
      "sanguineous": "रक्तीय",
      "serosanguineous": "सीरो-सैंगुइनस",
      "purulent": "प्यूरुलेंट"
    },
    "drainageAmount": {
      "none": "कोई नहीं",
      "scant": "बहुत कम",
      "small": "कम",
      "moderate": "मध्यम",
      "large": "अधिक",
      "copious": "बहुत अधिक"
    },
    "woundType": {
      "pressure": "दबाव क्षति",
      "surgical": "शल्य चिकित्सा (घाव)",
      "diabetic": "मधुमेह अल्सर",
      "venous": "शिरापरक अल्सर",
      "arterial": "धमनी अल्सर",
      "traumatic": "अभिघातजन्य",
      "skinTear": "त्वचा विदरण",
      "other": "अन्य"
    },
    "location": {
      "sacrum": "त्रिकास्थि",
      "coccyx": "अनुत्रिक",
      "leftHeel": "बायीं एड़ी",
      "rightHeel": "दायीं एड़ी",
      "leftTrochanter": "बायां ट्रोकेंटर",
      "rightTrochanter": "दायां ट्रोकेंटर",
      "abdomen": "उदर",
      "leftLeg": "बायां पैर",
      "rightLeg": "दायां पैर",
      "back": "पीठ",
      "other": "अन्य"
    },
    "surroundingSkin": {
      "intact": "अक्षत",
      "erythema": "रक्तिमा",
      "macerated": "गलन",
      "indurated": "कठोरता",
      "edematous": "शोफ",
      "warm": "उष्ण",
      "discolored": "विवर्ण"
    }
  },
  "carePlan": {
    "title": "देखभाल योजनाएँ",
    "addPlan": "देखभाल योजना जोड़ें",
    "newPlan": "नई देखभाल योजना",
    "createPlan": "योजना बनाएँ",
    "cancel": "रद्द करें",
    "empty": "इस रोगी के लिए कोई देखभाल योजना दर्ज नहीं है।",
    "emptyGoals": "अभी कोई लक्ष्य निर्धारित नहीं है।",
    "goals": "लक्ष्य",
    "addGoal": "लक्ष्य जोड़ें",
    "saving": "सहेज रहा है...",
    "loading": "देखभाल योजनाएँ लोड हो रही हैं...",
    "loadError": "देखभाल योजनाएँ लोड करने में विफल।",
    "fields": {
      "title": "शीर्षक",
      "startDate": "आरंभ तिथि",
      "targetDate": "लक्ष्य तिथि",
      "description": "विवरण",
      "target": "लक्ष्य"
    },
    "placeholders": {
      "title": "उदा. गिरने से बचाव की योजना",
      "description": "लक्ष्य का विवरण",
      "target": "उदा. 30 दिनों में कोई गिरावट नहीं"
    },
    "history": {
      "startLabel": "आरंभ",
      "targetLabel": "लक्ष्य",
      "goalsLabel": "लक्ष्य"
    },
    "status": {
      "active": "सक्रिय",
      "completed": "पूर्ण",
      "cancelled": "रद्द"
    },
    "goalStatus": {
      "inProgress": "प्रगति में",
      "achieved": "प्राप्त",
      "notAchieved": "अप्राप्त"
    },
    "toast": {
      "planCreated": "देखभाल योजना बनाई गई",
      "planCreateFailed": "देखभाल योजना बनाने में विफल",
      "goalAdded": "लक्ष्य जोड़ा गया",
      "goalAddFailed": "लक्ष्य जोड़ने में विफल",
      "planValidation": "शीर्षक और आरंभ तिथि आवश्यक हैं",
      "goalValidation": "विवरण और लक्ष्य आवश्यक हैं"
    }
  }
}
